import React from "react";
import BaseScreen from "./src/components/base";

export const wrapPageElement = ({ element, props }) => (
  <BaseScreen {...props}>{element}</BaseScreen>
);
